/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { arrayOf, date, DateFormat, entity, enumeration } from '@gh/core-data';
import { ContactCustomerType } from '../contacts';
import { Priority, SalesFolderStatus, Stage } from '../leads';
import {
  EmailCampaignDetailsDto,
  EmailCampaignListItemDto,
  EmailCampaignRecipientFilterDto,
  EmailCampaignReportDto,
  EmailCampaignStatus,
} from './email-campaigns.dto';

export const EmailCampaignListItemMapper = entity<EmailCampaignListItemDto>({
  statusValue: enumeration(EmailCampaignStatus),
  performedDate: date(DateFormat.DateTime),
  addedDate: date(DateFormat.DateTime),
});

export const EmailCampaignReportMapper = entity<EmailCampaignReportDto>({
  deliveryDate: date(DateFormat.DateTime),
  lastOpenedDate: date(DateFormat.DateTime),
  lastClickDate: date(DateFormat.DateTime),
});

export const EmailCampaignDetailsMapper = entity<EmailCampaignDetailsDto>({
  status: enumeration(EmailCampaignStatus),
  priorities: arrayOf(enumeration(Priority)),
  salesFolderStages: arrayOf(enumeration(Stage)),
  performedDate: date(DateFormat.DateTime),
  typeOfCustomer: enumeration(ContactCustomerType),
  salesFolderStatus: enumeration(SalesFolderStatus),
});

export const EmailCampaignRecipientFilterMapper = entity<EmailCampaignRecipientFilterDto>({
  salesFolderStatus: enumeration(SalesFolderStatus),
  salesFolderStages: arrayOf(enumeration(Stage)),
  customerType: enumeration(ContactCustomerType),
  priorities: arrayOf(enumeration(Priority)),
});
